import { useCallback } from 'react'
import { useSearchParams } from 'react-router'
import { useLocalStorage } from 'usehooks-ts'

import { SortDirectionToggle as BaseSortDirectionToggle } from '@fv/client-components'
import { parseQueryString, stringifyQueryString } from '@fv/client-core'
import type { SortDir } from '@fv/models'

type SortDirectionToggleProps = {
  sortDirection: SortDir
  localStorageKey?: string
}

export const SortDirectionToggle = ({
  sortDirection,
  localStorageKey,
}: SortDirectionToggleProps) => {
  const [, setSearchParams] = useSearchParams()
  const [, setLsValue] = useLocalStorage<SortDir>(
    localStorageKey ?? 'list-sort-direction',
    undefined,
  )

  const handleChange = useCallback(
    (val: SortDir) => {
      setSearchParams(p =>
        stringifyQueryString({
          ...parseQueryString(p.toString()),
          sortDirection: val,
        }),
      )
      if (localStorageKey) {
        setLsValue(val)
      }
    },
    [setSearchParams, setLsValue, localStorageKey],
  )

  return (
    <BaseSortDirectionToggle value={sortDirection} onChange={handleChange} />
  )
}
